import React, { useRef, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';

import { DASHBOARD_ROUTES } from '../../api/routes';
import { Container, Row, Col } from 'aplazame-design-system';

import style from './style.module.scss';
import './prism.scss';
import transitionStyle from 'aplazame-design-system/src/scss/transitions.module.scss';


export default function DocumentationApiSection({
    content
}) {
    const contentRef = useRef();

    const data = useStaticQuery(graphql`
        query {
            hashes: datoCmsSetting {
                loginB2bHash
            }
        }
    `);

    useEffect(() => {
        if (!contentRef.current) {
            return;
        }

        let tabs = [ ...contentRef.current.querySelectorAll('.tabs') ];
        tabs.forEach(tab => {
            let buttons = [ ...tab.querySelectorAll('.tab') ];
            let pres = [ ...tab.parentElement.querySelectorAll('pre') ];
            
            buttons.forEach(button => {
                button.addEventListener('click', () => {
                    if (button.classList.contains('active')) {
                        return;
                    }

                    let datasetItem = button.dataset.codelang ? 'codelang' : 'label';

                    let item = button.dataset[datasetItem];

                    if (item) {
                        pres.forEach(pre => {
                            pre.style.display = pre.dataset[datasetItem] === item ? 'block' : 'none';
                        });

                        buttons.forEach(thisButton => {
                            if (thisButton.dataset[datasetItem] === item) {
                                thisButton.classList.add('active');
                            } else {
                                thisButton.classList.remove('active');
                            }
                        });
                    }
                });
            });

            let apikeyTrigger = [ ...contentRef.current.querySelectorAll('[data-apikey]') ];
            apikeyTrigger.forEach(trigger => {
                trigger.addEventListener('click', () => {
                    const isMerchant = window.document.body.dataset.logged && window.document.body.dataset.logged === 'vendor';
                    if (isMerchant) {
                        window.open(DASHBOARD_ROUTES.vendors);
                    } else {
                        window.location.hash = `#${data.hashes.loginB2bHash}`;
                    }
                });
            });
        });
    }, [ contentRef, data ]);

    return (
        <section>
            <Container
                pt={{
                    xs: 5,
                    lg: 6
                }}
                pb={{
                    xs: 20
                }}
            >
                <Row>
                    <Col 
                        col={{ lg: 7 }}
                        offset={{ lg: 3 }}
                    >
                        <div 
                            ref={contentRef}
                            className={`${style.content} ${transitionStyle['child-link-underline']}`}
                            dangerouslySetInnerHTML={{ __html: content }}
                        />
                    </Col>
                </Row>
            </Container>
        </section>
    );
}